import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { PageHero, Section, Breadcrumbs, Prose } from "@/components/site/Sections";
import { ContactForm } from "@/components/site/ContactForm";

const TITLE = "Indhent tilbud på elektriker | Elektriker-Elektriker";
const DESCRIPTION =
  "Få et uforpligtende tilbud på din elektrikeropgave i København & omegn. Udfyld formularen, så vender vi hurtigt tilbage med pris og tidspunkt.";

export const Route = createFileRoute("/tilbud")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "/tilbud" },
    ],
    links: [{ rel: "canonical", href: "https://elektriker-elektriker.dk/tilbud" }],
  }),
  component: TilbudPage,
});

function TilbudPage() {
  return (
    <SiteShell>
      <Breadcrumbs items={[{ label: "Forside", to: "/" }, { label: "Indhent tilbud" }]} />
      <PageHero
        variant="compact"
        accentColor="oklch(0.7 0.16 145)"
        eyebrow="Indhent tilbud · Svar samme dag"
        title="Få et uforpligtende tilbud på din elektrikeropgave"
        intro="Fortæl os kort om din opgave. Vi vender tilbage med et skriftligt tilbud og en mulig tid, typisk samme arbejdsdag. Du forpligter dig ikke til noget ved at sende formularen."
        hideCta
      />

      <Section className="!pt-0">
        <div className="grid gap-4 md:grid-cols-2">
          <a href="tel:+4528700028" className="group rounded-2xl border border-border bg-card p-6 transition hover:border-primary">
            <div className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">Ring direkte · Døgnvagt 24/7</div>
            <div className="mt-2 text-4xl font-bold text-primary md:text-5xl">+45 28 7000 28</div>
            <p className="mt-3 text-sm text-muted-foreground">Hverdage 7–17. Akut udrykning også uden for åbningstid og i weekenden.</p>
          </a>
          <a href="mailto:el@elektriker-elektriker.dk" className="group rounded-2xl border border-border bg-card p-6 transition hover:border-primary">
            <div className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">Skriv en mail</div>
            <div className="mt-2 break-all text-3xl font-bold text-[var(--ink)] md:text-4xl">el@elektriker-elektriker.dk</div>
            <p className="mt-3 text-sm text-muted-foreground">Vi svarer typisk samme arbejdsdag.</p>
          </a>
        </div>
      </Section>


      <Section>
        <div className="grid gap-10 md:grid-cols-[1.2fr_1fr]">
          <ContactForm variant="tilbud" />

          <Prose className="!mx-0">
            <h2>Hvad sker der efter du har sendt?</h2>
            <ol className="!list-decimal">
              <li><strong>Vi læser din forespørgsel.</strong> Typisk indenfor 1-2 arbejdstimer.</li>
              <li><strong>Vi ringer eller mailer.</strong> Vi spørger ind hvis vi mangler noget, fx fotos af tavlen eller information om hovedsikring.</li>
              <li><strong>Du modtager tilbud.</strong> Enten fast pris (større opgaver) eller estimat plus timepris (fejlfinding/service).</li>
              <li><strong>Du beslutter.</strong> Ingen forpligtelse. Vi presser dig ikke.</li>
            </ol>
            <h2>Skal det være akut?</h2>
            <p>
              Ring i stedet: <a href="tel:+4528700028">+45 28 7000 28</a>. Vi har døgnvagt 24/7 og
              rykker ud i hele Storkøbenhavn, typisk indenfor 1-2 timer i åbningstiden.
            </p>
          </Prose>
        </div>
      </Section>
    </SiteShell>
  );
}
